import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'
import moduleNotices from './notices/moduleNotices.js'
import moduleFile from '@/store/file/moduleFile'
import moduleEnum from '@/store/enum/moduleEnum'
import moduleConfig from '@/store/config/moduleConfig'
import moduleInvoice from '@/store/invoice/moduleInvoice'
import moduleWallet from '@/store/wallet/moduleWallet'
import moduleRequest from '@/store/request/moduleRequest'
import moduleChat from '@/store/chat/moduleChat'
import moduleAffiliate from '@/store/affiliate/moduleAffiliate'
import moduleGift from '@/store/gift/moduleGift'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    notices: moduleNotices,
    file: moduleFile,
    enum: moduleEnum,
    config: moduleConfig,
    invoice: moduleInvoice,
    wallet: moduleWallet,
    request: moduleRequest,
    chat: moduleChat,
    affiliate: moduleAffiliate,
    gift: moduleGift
  },
  strict: process.env.NODE_ENV !== 'production'
})
